import { css } from '@emotion/react';
import React from 'react';

import { Spacer } from '@/ui/spacing';
import { BodyCopy, Heading } from '@/ui/typography';

interface GleneaglesServiceChargeCardProps {}

export const GleneaglesServiceChargeCard: React.FC<
  GleneaglesServiceChargeCardProps
> = () => {
  return (
    <div>
      <Heading style="heading5" as="h5">{`Billing Instructions`}</Heading>
      <Spacer s="xs" />
      <BodyCopy css={css({ maxWidth: '700px' })}>
        {`Guest to settle remaining accommodation package upon check in to the hotel. Additionally, a £200 deposit will be taken on arrival for any incidentals, which can be used or refunded when settling the outstanding total on departure.`}
      </BodyCopy>
      <Spacer s="l" />
      <Heading
        style="heading5"
        as="h5"
      >{`Discretionary Service Charge`}</Heading>
      <Spacer s="xs" />
      <BodyCopy css={css({ maxWidth: '700px' })}>
        {`In support of the outstanding commitment our staff make and the
        exceptional service they provide, we will add a discretionary 5% service
        charge on your room rate. This will be added to your bill upon checkout
        of the hotel. In addition, dining bills and leisure activities will
        include a 12.5% discretionary service charge (some exclusions apply).`}
      </BodyCopy>
    </div>
  );
};
